module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/users/user-detail/user-detail.component.scss
// module id = ./src/app/users/user-detail/user-detail.component.scss
// module chunks = main